export function createWebPlatform() {
  return {
    id: 'web',
    theme: {
      applyFromHost() {},
    },
    auth: {
      async ensureSession() {},
      getLaunchContext() {
        return {};
      },
    },
    chrome: {
      ready() {},
      haptic() {},
    },
  };
}

export function detectPlatform() {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp?.initData) {
    return {
      id: 'telegram',
      theme: {
        applyFromHost() {
          const tp = window.Telegram.WebApp.themeParams || {};
          const root = document.documentElement;
          if (tp.bg_color) root.style.setProperty('--color-bg', tp.bg_color);
          if (tp.secondary_bg_color) root.style.setProperty('--color-surface', tp.secondary_bg_color);
          if (tp.text_color) root.style.setProperty('--color-text', tp.text_color);
          if (tp.hint_color) root.style.setProperty('--color-text-muted', tp.hint_color);
          if (tp.button_color) root.style.setProperty('--color-primary', tp.button_color);
          if (tp.button_text_color) root.style.setProperty('--color-text-inverse', tp.button_text_color);
          if (tp.destructive_text_color) root.style.setProperty('--color-danger', tp.destructive_text_color);
        },
      },
      auth: {
        async ensureSession() {},
        getLaunchContext() {
          return { startParam: window.Telegram.WebApp.initDataUnsafe?.start_param };
        },
      },
      chrome: {
        ready() {
          window.Telegram.WebApp.ready();
          window.Telegram.WebApp.expand?.();
        },
        haptic(kind = 'light') {
          try {
            if (kind === 'success') window.Telegram.WebApp.HapticFeedback?.notificationOccurred('success');
            else window.Telegram.WebApp.HapticFeedback?.impactOccurred('light');
          } catch {
            /* ignore */
          }
        },
        close() {
          window.Telegram.WebApp.close?.();
        },
      },
      initData: window.Telegram.WebApp.initData,
    };
  }

  return createWebPlatform();
}
